(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.mobileMediaQuery) {
        this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      }

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      const openDetails = this.querySelectorAll('details[open]');
      openDetails.forEach((details) => {
        details.removeAttribute('open');
      });
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaiqa-box-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBuilder = (root) => {
      if (!root || root.dataset.zbReady === 'true') return;
      root.dataset.zbReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-zb-product]'));
      const categoryButtons = Array.from(root.querySelectorAll('[data-zb-category]'));
      const summary = root.querySelector('[data-zb-summary]');
      const continueButton = root.querySelector('[data-zb-continue]');
      const continueText = root.querySelector('[data-zb-continue-text]');
      const mobileContinue = root.querySelector('[data-zb-mobile-continue]');
      const mobileBar = root.querySelector('[data-zb-mobile-bar]');
      const modal = root.querySelector('[data-zb-modal]');
      const toast = root.querySelector('[data-zb-toast]');
      const whatsappButton = root.querySelector('[data-zb-whatsapp]');

      if (!cards.length || !summary) return;

      const settings = {
        currency: root.dataset.currency || 'PKR',
        productLimit: Number(root.dataset.productLimit || 30),
        enableMin: root.dataset.enableMin === 'true',
        minValue: Number(root.dataset.minValue || 0),
        enableMax: root.dataset.enableMax === 'true',
        maxValue: Number(root.dataset.maxValue || 0),
        enableDiscount: root.dataset.enableDiscount === 'true',
        discountPercent: Number(root.dataset.discountPercent || 0),
        discountCode: root.dataset.discountCode || '',
        afterAdd: root.dataset.afterAdd || 'cart',
        cartAddUrl: root.dataset.cartAddUrl || '/cart/add.js',
        cartUrl: root.dataset.cartUrl || '/cart',
        boxName: root.dataset.boxName || 'Custom Box',
        minMessage: root.dataset.minMessage || 'Add {amount} more to reach the minimum box value.',
        maxMessage: root.dataset.maxMessage || 'Maximum box value reached.',
        addedMessage: root.dataset.addedMessage || 'Added to your box.',
        removedMessage: root.dataset.removedMessage || 'Removed from your box.',
        errorMessage: root.dataset.errorMessage || 'Something went wrong. Please try again.',
        whatsappEnabled: root.dataset.whatsappEnabled === 'true',
        whatsappNumber: (root.dataset.whatsappNumber || '').replace(/\D/g, '')
      };

      const state = new Map();
      let pendingRemoval = null;
      let toastTimer = null;
      let isSubmitting = false;

      const money = (cents) => {
        const value = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: settings.currency,
            maximumFractionDigits: Number.isInteger(value) ? 0 : 2
          }).format(value);
        } catch (error) {
          return `${settings.currency} ${value.toLocaleString()}`;
        }
      };

      const replaceAmount = (message, amount) => message.replace('{amount}', money(amount));

      const showToast = (message) => {
        if (!toast || !message) return;
        toast.textContent = message;
        toast.classList.add('is-visible');
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 1800);
      };

      const cardStateFromDom = (card) => ({
        card,
        productId: card.dataset.productId,
        title: card.dataset.productTitle,
        variantId: Number(card.dataset.variantId || 0),
        price: Number(card.dataset.price || 0),
        available: card.dataset.available === 'true',
        maxInventory: Number(card.dataset.maxInventory || -1),
        qty: Number(card.dataset.qty || 0)
      });

      cards.forEach((card) => state.set(card.dataset.productId, cardStateFromDom(card)));

      const productsGrid = root.querySelector('[data-zb-products]');
      if (productsGrid && cards.length > 1) {
        const shuffledCards = [...cards];
        for (let i = shuffledCards.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffledCards[i], shuffledCards[j]] = [shuffledCards[j], shuffledCards[i]];
        }
        shuffledCards.forEach((card) => productsGrid.appendChild(card));
      }

      const totals = () => {
        let items = 0;
        let subtotal = 0;

        state.forEach((item) => {
          items += item.qty;
          subtotal += item.price * item.qty;
        });

        const saving = settings.enableDiscount
          ? Math.round(subtotal * (settings.discountPercent / 100))
          : 0;

        return {
          items,
          subtotal,
          saving,
          total: Math.max(0, subtotal - saving)
        };
      };

      const setCardQty = (item, qty) => {
        item.qty = Math.max(0, qty);
        item.card.dataset.qty = String(item.qty);
        const qtyEl = item.card.querySelector('[data-zb-qty-value]');
        if (qtyEl) qtyEl.textContent = String(item.qty);
        item.card.classList.toggle('is-in-box', item.qty > 0);
      };

      const updateSummary = () => {
        const current = totals();
        const itemsEl = root.querySelector('[data-zb-items]');
        const subtotalEl = root.querySelector('[data-zb-subtotal]');
        const savingEl = root.querySelector('[data-zb-saving]');
        const totalEl = root.querySelector('[data-zb-total]');
        const mobileItemsEl = root.querySelector('[data-zb-mobile-items]');
        const mobileTotalEl = root.querySelector('[data-zb-mobile-total]');
        const progressEl = root.querySelector('[data-zb-progress]');
        const progressTextEl = root.querySelector('[data-zb-progress-text]');

        if (itemsEl) itemsEl.textContent = String(current.items);
        if (subtotalEl) subtotalEl.textContent = money(current.subtotal);
        if (savingEl) savingEl.textContent = `${money(current.saving)} (${settings.discountPercent}%)`;
        if (totalEl) totalEl.textContent = money(current.total);
        if (mobileItemsEl) mobileItemsEl.textContent = `${current.items} item${current.items === 1 ? '' : 's'}`;
        if (mobileTotalEl) mobileTotalEl.textContent = money(current.total);

        if (progressEl) {
          let progress = 0;
          if (settings.enableMax && settings.maxValue > 0) {
            progress = (current.subtotal / settings.maxValue) * 100;
          } else if (settings.enableMin && settings.minValue > 0) {
            progress = (current.subtotal / settings.minValue) * 100;
          }
          progressEl.style.width = `${Math.min(100, Math.max(0, progress))}%`;
        }

        if (progressTextEl) {
          if (settings.enableMin && current.subtotal < settings.minValue) {
            progressTextEl.textContent = replaceAmount(settings.minMessage, settings.minValue - current.subtotal);
          } else if (settings.enableMax && current.subtotal >= settings.maxValue) {
            progressTextEl.textContent = settings.maxMessage;
          } else if (settings.enableMax) {
            progressTextEl.textContent = `${money(settings.maxValue - current.subtotal)} room left before the maximum.`;
          } else if (settings.enableMin) {
            progressTextEl.textContent = 'Minimum box value reached.';
          } else {
            progressTextEl.textContent = '';
          }
        }

        const belowMinimum = settings.enableMin && current.subtotal < settings.minValue;
        if (continueButton) {
          continueButton.classList.toggle('is-disabled-looking', belowMinimum || current.items === 0);
          continueButton.setAttribute('aria-disabled', String(belowMinimum || current.items === 0));
        }
      };

      const canAdd = (item) => {
        if (!item.available) {
          showToast('This variant is sold out.');
          return false;
        }

        if (item.maxInventory >= 0 && item.qty + 1 > item.maxInventory) {
          showToast(`Only ${item.maxInventory} available for ${item.title}.`);
          return false;
        }

        const current = totals();
        if (settings.enableMax && current.subtotal + item.price > settings.maxValue) {
          showToast(settings.maxMessage);
          return false;
        }

        return true;
      };

      const openRemoveModal = (item) => {
        if (!modal) {
          setCardQty(item, item.qty - 1);
          updateSummary();
          showToast(settings.removedMessage);
          return;
        }

        pendingRemoval = item;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        const closeButton = modal.querySelector('[data-zb-modal-close]');
        if (closeButton) closeButton.focus();
      };

      const closeRemoveModal = () => {
        if (!modal) return;
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        pendingRemoval = null;
      };

      const confirmRemove = () => {
        if (!pendingRemoval) return closeRemoveModal();
        const item = pendingRemoval;
        setCardQty(item, Math.max(0, item.qty - 1));
        closeRemoveModal();
        updateSummary();
        showToast(settings.removedMessage);
      };

      const shuffleProductCards = () => {
        const container = root.querySelector('[data-zb-products]');
        if (!container) return;

        const shuffled = Array.from(container.querySelectorAll('[data-zb-product]'));
        for (let i = shuffled.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        shuffled.forEach((card) => container.appendChild(card));
      };

      const filterProducts = (handle) => {
        categoryButtons.forEach((button) => {
          const active = button.dataset.zbCategory === handle;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        let allVisibleCount = 0;

        cards.forEach((card) => {
          if (handle === 'all') {
            const shouldShow = allVisibleCount < settings.productLimit;
            card.hidden = !shouldShow;
            if (shouldShow) allVisibleCount += 1;
            return;
          }

          const tokens = card.dataset.collections || '';
          card.hidden = !tokens.includes(`|${handle}|`);
        });
      };

      const selectedItems = () => {
        const boxId = `BOX-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
        const items = [];

        state.forEach((item) => {
          if (item.qty <= 0 || !item.variantId) return;
          items.push({
            id: item.variantId,
            quantity: item.qty,
            properties: {
              'Box': settings.boxName,
              '_Box ID': boxId
            }
          });
        });

        return { items, boxId };
      };

      const setSubmitting = (busy) => {
        isSubmitting = busy;
        if (continueButton) continueButton.disabled = busy;
        if (mobileContinue) mobileContinue.disabled = busy;
        if (continueText) continueText.textContent = busy ? 'ADDING…' : continueText.dataset.originalText || continueText.textContent;
      };

      if (continueText) continueText.dataset.originalText = continueText.textContent;

      const redirectAfterAdd = () => {
        const target = settings.afterAdd === 'checkout' ? '/checkout' : settings.cartUrl;

        if (settings.enableDiscount && settings.discountCode.trim()) {
          window.location.href = `/discount/${encodeURIComponent(settings.discountCode.trim())}?redirect=${encodeURIComponent(target)}`;
          return;
        }

        window.location.href = target;
      };

      const addBoxToCart = async () => {
        if (isSubmitting) return;
        const current = totals();

        if (current.items <= 0) {
          showToast('Add at least one product to your box.');
          return;
        }

        if (settings.enableMin && current.subtotal < settings.minValue) {
          showToast(replaceAmount(settings.minMessage, settings.minValue - current.subtotal));
          if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (settings.enableMax && current.subtotal > settings.maxValue) {
          showToast(settings.maxMessage);
          return;
        }

        const payload = selectedItems();
        if (!payload.items.length) return;

        setSubmitting(true);

        try {
          const response = await fetch(settings.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: payload.items })
          });

          if (!response.ok) {
            let errorMessage = settings.errorMessage;
            try {
              const errorData = await response.json();
              if (errorData && errorData.description) errorMessage = errorData.description;
            } catch (error) {}
            throw new Error(errorMessage);
          }

          redirectAfterAdd();
        } catch (error) {
          setSubmitting(false);
          showToast(error.message || settings.errorMessage);
        }
      };

      const whatsappOrder = () => {
        if (!settings.whatsappEnabled || !settings.whatsappNumber) return;
        const current = totals();

        if (!current.items) {
          showToast('Add at least one product to your box.');
          return;
        }

        if (settings.enableMin && current.subtotal < settings.minValue) {
          showToast(replaceAmount(settings.minMessage, settings.minValue - current.subtotal));
          return;
        }

        const lines = [`${settings.boxName}:`];
        state.forEach((item) => {
          if (item.qty > 0) lines.push(`• ${item.title} × ${item.qty}`);
        });
        lines.push(`Total: ${money(current.total)}`);
        window.open(`https://wa.me/${settings.whatsappNumber}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener');
      };

      root.addEventListener('click', (event) => {
        const category = event.target.closest('[data-zb-category]');
        if (category) {
          filterProducts(category.dataset.zbCategory || 'all');
          return;
        }

        const plus = event.target.closest('[data-zb-plus]');
        if (plus) {
          const card = plus.closest('[data-zb-product]');
          const item = card ? state.get(card.dataset.productId) : null;
          if (item && canAdd(item)) {
            setCardQty(item, item.qty + 1);
            updateSummary();
            showToast(settings.addedMessage);
          }
          return;
        }

        const minus = event.target.closest('[data-zb-minus]');
        if (minus) {
          const card = minus.closest('[data-zb-product]');
          const item = card ? state.get(card.dataset.productId) : null;
          if (!item || item.qty <= 0) return;

          if (item.qty === 1) {
            openRemoveModal(item);
          } else {
            setCardQty(item, item.qty - 1);
            updateSummary();
          }
          return;
        }

        if (event.target.closest('[data-zb-continue]') || event.target.closest('[data-zb-mobile-continue]')) {
          addBoxToCart();
          return;
        }

        if (event.target.closest('[data-zb-modal-close]') || event.target.closest('[data-zb-keep]')) {
          closeRemoveModal();
          return;
        }

        if (event.target.closest('[data-zb-remove-confirm]')) {
          confirmRemove();
          return;
        }

        if (event.target.closest('[data-zb-whatsapp]')) {
          whatsappOrder();
        }
      });

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-zb-variant-select]');
        if (!select) return;

        const card = select.closest('[data-zb-product]');
        const item = card ? state.get(card.dataset.productId) : null;
        const option = select.options[select.selectedIndex];
        if (!item || !option) return;

        const newVariantId = Number(option.value || 0);
        const newPrice = Number(option.dataset.price || 0);
        const newAvailable = option.dataset.available === 'true';
        const newMaxInventory = Number(option.dataset.maxInventory || -1);

        if (item.qty > 0 && settings.enableMax) {
          const current = totals();
          const projected = current.subtotal - (item.price * item.qty) + (newPrice * item.qty);
          if (projected > settings.maxValue) {
            const previousOption = Array.from(select.options).find((candidate) => Number(candidate.value) === item.variantId);
            if (previousOption) previousOption.selected = true;
            showToast(settings.maxMessage);
            return;
          }
        }

        if (item.qty > 0 && newMaxInventory >= 0 && item.qty > newMaxInventory) {
          const previousOption = Array.from(select.options).find((candidate) => Number(candidate.value) === item.variantId);
          if (previousOption) previousOption.selected = true;
          showToast(`Only ${newMaxInventory} available for this variant.`);
          return;
        }

        item.variantId = newVariantId;
        item.price = newPrice;
        item.available = newAvailable;
        item.maxInventory = newMaxInventory;
        card.dataset.variantId = String(newVariantId);
        card.dataset.price = String(newPrice);
        card.dataset.available = String(newAvailable);
        card.dataset.maxInventory = String(newMaxInventory);

        const priceEl = card.querySelector('[data-zb-unit-price]');
        const plusButton = card.querySelector('[data-zb-plus]');
        if (priceEl) priceEl.textContent = money(newPrice);
        if (plusButton) plusButton.disabled = !newAvailable;
        card.classList.toggle('is-sold-out', !newAvailable);
        updateSummary();
      });

      if (modal) {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) closeRemoveModal();
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal && !modal.hidden) closeRemoveModal();
      });

      if ('IntersectionObserver' in window && mobileBar) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          mobileBar.classList.toggle('is-visible', Boolean(entry && entry.isIntersecting));
          mobileBar.setAttribute('aria-hidden', String(!(entry && entry.isIntersecting)));
        }, { threshold: 0.02 });
        observer.observe(root);
      } else if (mobileBar) {
        mobileBar.classList.add('is-visible');
        mobileBar.setAttribute('aria-hidden', 'false');
      }


      shuffleProductCards();
      filterProducts('all');
      updateSummary();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-zaiqa-builder]').forEach(initBuilder);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
